import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { Info } from '../../core/common';
import { IState, ICountry, INewUserLabel, INewUserSaveLabel } from '../../core/models';
import { UserService } from '../../core/services/user.service';
import { HelperService } from '../../core/services/helper.service';
import { LanguageTranslationService } from '../../core/services/language-translation.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-new-user',
  templateUrl: './new-user.component.html',
  styleUrls: ['./new-user.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NewUserComponent implements OnInit {
  newUserTxt: INewUserLabel;
  addNewUserForm: FormGroup;
  public inProgressMessage: boolean;
  public saveInProcess: boolean;
  public infoMessage: Info = new Info();
  public successMsgLbl: string = 'User registration request successfully submitted in the system. You will get notification once the registration request is approved.';
  public errorMsgLbl: string = 'Sorry! An error occured while submitting registration request. Please try again. If the problem persists then please contact Kawneer Admin(Include email id here).';
  public showStatus: boolean = false;
  public statusMsg: string = "";
  public value = '359884123321';
  public isDuplicateUser: boolean = false;
  public isUserNameVal: string = '';

  //public requireAccountSummary = false;
 // public requireInvoiceDetails = false;
  // public mask = '(999) 000-00-00-000';
  //REFACTOR THIS FORM --> Base api call shoul work, rework on validation etc...
  public maxlength = 40;
  public charachtersCount = 0;
  public counter = `${this.charachtersCount}/${this.maxlength}`;

  constructor(private formBuilder: FormBuilder,
    private userService: UserService,
    private helperService: HelperService, private languageTranslationService: LanguageTranslationService, private router:Router) { }

  ngOnInit() {
    this.loadLanguageTranslationData();
    this.initUserRegistrationForm();
    this.isDuplicateUser = false;
  }

  initUserRegistrationForm() {
    this.addNewUserForm = this.formBuilder.group({
      userName: new FormControl(""),
      password: new FormControl(""),
      firstName: new FormControl(""),
      lastName: new FormControl(""),
      phoneNumber: new FormControl(""),
      email: new FormControl(""),
      confirmEmail: new FormControl(""),
      companyName: new FormControl(""),
      companyAccNumber: new FormControl(""),
      billingStreet1Address: new FormControl(""),
      billingStreet2Address: new FormControl(""),
      billingCity: new FormControl(""),
      billingState: new FormControl(""),
      billingCounty: new FormControl(""),
      billingCountry: new FormControl(""),
      billingZipCode: new FormControl(""),
      billingPhoneNumber: new FormControl(""),
      requireInvoiceDetails: new FormControl(""),
      requireAccountSummary: new FormControl(""),      
    })
  }

  //#region Language translate
  loadLanguageTranslationData() {
    const controlNameList = [
      {controlName: "pageTitleLbl " },
      {controlName: "userNameLbl"},
      {controlName: "usernameNoteTooltip"},
      {controlName: "companyAccNumTooltip"},      
      {controlName: "passwordLbl" },
      {controlName: "firstNameLbl" },
      {controlName: "lastNameLbl " },
      {controlName: "emailLbl " },
      {controlName: "confirmEmailLbl" },
      {controlName: "phoneNumberLbl"},
      {controlName: "companyNameLbl"},
      {controlName: "companyAccNumberLbl"},
      {controlName: "invalidEmailLbl"},
      {controlName: "confirmEmailMatchLbl"},
      {controlName: "registerLbl"},
      {controlName: "resetLbl "},
      {controlName: "userNotAvailableLbl"},
      {controlName: "invalidPhoneLbl"},
      {controlName: "successMsgLbl "},
      { controlName: "errorMsgLbl  " },
      { controlName: "userNameSpecialCharLbl" },

    ];
    const componentName = "newuser";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.newUserTxt = response[response.length - 1];
    }
  }

  //#endregion
  saveMessage: INewUserSaveLabel = {
    successMsgLbl: '',
    errorMsgLbl:''
  }
  public newUserDialog = {
    opened: false,
    isSubmitted: false,
    pageTitleLbl: "New User Account Registration for Existing Kawneer Customers only",
    userNameLbl: "Username (Minimum 8 characters with no special character)",
    passwordLbl: "Password",
    firstNameLbl: "First Name",
    lastNameLbl: "Last Name",
    emailLbl: "Email",
    confirmEmailLbl: "Confirm Email",
    phoneNumberLbl: "Direct Phone Number",
    usernameNoteTooltip: "Retain username submitted on form. If your account is approved, this will be your permanent username.",
    companyAccNumTooltip: "Account Number can be found on any Kawneer order document. Please contact your Salesperson if number unknown.",
    companyNameLbl: "Company Name",
    companyAccNumberLbl: "Company Account Number",
    invalidEmailLbl: "Email address is invalid",
    confirmEmailMatchLbl: "Email and Confirm Email must be match.",
    registerLbl: "Register",
    resetLbl: "Reset",
    userNotAvailableLbl: "Username is not available",
    userNameSpecialCharLbl: "Username should not contain special character",
    invalidPhoneLbl: "Phone number length must be 10 digits",
    isInvalidUserId: false,
    isEmptyUserName: false,
    showUserNameIcon: false,
    userNameProcessing: false,
    isUserNameValid: false,
    isInvalidFirstName: false,
    isInvalidPassword: false,
    isInvalidLastName: false,
    isInvalidPhoneNumber: false,
    isInvalidPhoneNumberMessage: false,
    isInvalidEmail: false,
    isInvalidConfirmEmail: false,
    isInvalidCompanyName: false,
    isInvalidCompanyAccNumber: false,
    isEmailFormatInValid: false,
    isemailNotMatched: false,
    isInvalidStreet1Address: false,
    isInvalidStreet2Address: false,
    isInvalidCity: false,
    isInvalidState: false,
    isInvalidCounty: false,
    isInvalidCountry: false,
    isInvalidZipCode: false,
    isInvalidBillingPhoneNumber: false,
    isInvalidBillingPhoneNumberMessage: false,
    isValidForm: this.validateNewUserForm()
  };

  emailLeave() {
    const controls = this.addNewUserForm.controls;
    if (controls.email.value) {
      const res = this.helperService.isEmailFormatValid(controls.email.value);
      if (!res) {
        this.newUserDialog.isEmailFormatInValid = true;
        this.newUserDialog.isInvalidEmail = true;

      } else {
        this.newUserDialog.isEmailFormatInValid = false;
        this.newUserDialog.isInvalidEmail = false;
      }

    } else {
      if (this.newUserDialog.isSubmitted) {
        this.newUserDialog.isEmailFormatInValid = false;
        this.newUserDialog.isInvalidEmail = true;
      }
    }

  }
  confirmEmailLeave() {
    const controls = this.addNewUserForm.controls;
    if (controls.confirmEmail.value) {
      if (controls.email.value) {
        if (controls.confirmEmail.value != controls.email.value) {
          this.newUserDialog.isInvalidConfirmEmail = true;
          this.newUserDialog.isemailNotMatched = true;
        }
        else {
          this.newUserDialog.isInvalidConfirmEmail = false;
          this.newUserDialog.isemailNotMatched = false;
        }
      }
    } else {
      if (this.newUserDialog.isSubmitted) {
        this.newUserDialog.isInvalidConfirmEmail = true;
        this.newUserDialog.isemailNotMatched = false;
      }
    }
  }
  public validateNewUserForm(): boolean {
    let isValid = true;
    if (!this.newUserDialog) {
      return;
    }
    const controls = this.addNewUserForm.controls;

    if (this.newUserDialog.isSubmitted) {

      if (controls.userName.value) {
        this.newUserDialog.isEmptyUserName = false;
      } else {
        this.newUserDialog.isEmptyUserName = true;
        isValid = false;
      }
      if (controls.email.value) {
        const res = this.helperService.isEmailFormatValid(controls.email.value);
        if (!res) {
          this.newUserDialog.isEmailFormatInValid = true;
          this.newUserDialog.isInvalidEmail = true;
          isValid = false;
        } else {
          this.newUserDialog.isEmailFormatInValid = false;
          this.newUserDialog.isInvalidEmail = false;
        }

      } else {
        this.newUserDialog.isInvalidEmail = true;
        isValid = false;
      }
      if (controls.firstName.value) {
        this.newUserDialog.isInvalidFirstName = false;
      } else {
        this.newUserDialog.isInvalidFirstName = true;
        isValid = false;
      }
      if (controls.lastName.value) {
        this.newUserDialog.isInvalidLastName = false;
      } else {
        this.newUserDialog.isInvalidLastName = true;
        isValid = false;
      }

      if (controls.confirmEmail.value) {
        if (controls.confirmEmail.value != controls.email.value) {
          this.newUserDialog.isInvalidConfirmEmail = true;
          this.newUserDialog.isemailNotMatched = true;
          isValid = false;
        }
        else {
          this.newUserDialog.isInvalidConfirmEmail = false;
          this.newUserDialog.isemailNotMatched = false;
        }

      } else {
        this.newUserDialog.isInvalidConfirmEmail = true;
        this.newUserDialog.isemailNotMatched = false;
        isValid = false;
      }
      if (controls.companyName.value) {
        this.newUserDialog.isInvalidCompanyName = false;
      } else {
        this.newUserDialog.isInvalidCompanyName = true;
        isValid = false;
      }
      if (controls.companyAccNumber.value) {
        this.newUserDialog.isInvalidCompanyAccNumber = false;
      } else {
        this.newUserDialog.isInvalidCompanyAccNumber = true;
        isValid = false;
      }
      if (controls.billingStreet1Address.value) {
        this.newUserDialog.isInvalidStreet1Address = false;
      } else {
        this.newUserDialog.isInvalidStreet1Address = true;
        isValid = false;
      }
      if (controls.billingCity.value) {
        this.newUserDialog.isInvalidCity= false;
      } else {
        this.newUserDialog.isInvalidCity = true;
        isValid = false;
      }
      if (controls.billingState.value) {
        this.newUserDialog.isInvalidState = false;
      } else {
        this.newUserDialog.isInvalidState = true;
        isValid = false;
      }
      if (controls.billingCountry.value) {
        this.newUserDialog.isInvalidCountry = false;
      } else {
        this.newUserDialog.isInvalidCountry = true;
        isValid = false;
      }
      if (controls.billingZipCode.value) {
        this.newUserDialog.isInvalidZipCode = false;
      } else {
        this.newUserDialog.isInvalidZipCode  = true;
        isValid = false;
      }
      if (controls.phoneNumber.value) {
        this.newUserDialog.isInvalidPhoneNumber = false;
        if ((controls.phoneNumber.value as string).toString().length !== 10) {
          this.newUserDialog.isInvalidPhoneNumber = true;
          this.newUserDialog.isInvalidPhoneNumberMessage = true;
          isValid = false;
        } else {
          this.newUserDialog.isInvalidPhoneNumber = false;
          this.newUserDialog.isInvalidPhoneNumberMessage = false;
        }
      } else {
        this.newUserDialog.isInvalidPhoneNumber = true;
        isValid = false;
      }
      if (controls.billingPhoneNumber.value) {
        this.newUserDialog.isInvalidBillingPhoneNumber = false;
        if ((controls.billingPhoneNumber.value as string).toString().length !== 10) {
          this.newUserDialog.isInvalidBillingPhoneNumber = true;
          this.newUserDialog.isInvalidBillingPhoneNumberMessage = true;
          isValid = false;
        } else {
          this.newUserDialog.isInvalidBillingPhoneNumber = false;
          this.newUserDialog.isInvalidBillingPhoneNumberMessage = false;
        }
      } else {
        this.newUserDialog.isInvalidBillingPhoneNumber = true;
        isValid = false;
      }
    }
    return isValid;
  }

  public registerUser() {
    this.newUserDialog.isSubmitted = true;
    if (!this.validateNewUserForm()) {
      return;
    }
    

    if (!this.newUserDialog.isUserNameValid) {
      this.isUserNameVal = this.newUserTxt.userNotAvailableLbl ? this.newUserTxt.userNotAvailableLbl : this.newUserDialog.userNotAvailableLbl;
      return;
    }
    
    //if (!this.newUserDialog.is) {
    //  this.isDuplicateUser = true;
    //  return;
    //}
    const controls = this.addNewUserForm.controls;
    const body = {
      userName: controls.userName.value,//unique validation
      password: "Test123$",    //need change
      firstName: controls.firstName.value,
      lastName: controls.lastName.value,
      phoneNumber: controls.phoneNumber.value ? controls.phoneNumber.value.toString() : "",//though unlikely
      email: controls.email.value,
      languageCode: 'eng',
      companyName: controls.companyName.value,
      companyAccountNumber: controls.companyAccNumber.value.toString(),
      billingStreet1Address: controls.billingStreet1Address.value,
      billingStreet2Address: controls.billingStreet2Address.value,
      billingCity: controls.billingCity.value,
      billingState: controls.billingState.value,
      billingCounty: controls.billingCounty.value,
      billingCountry: controls.billingCountry.value,
      billingZipCode: controls.billingZipCode.value,
      billingPhoneNumber: controls.billingPhoneNumber.value.toString(),      
      RequireInvoiceDetails: controls.requireInvoiceDetails.value ? true:false,
      RequireAccountSummary: controls.requireAccountSummary.value?true:false
    }
    
    this.userService.registerUser(body).subscribe((response: any) => {
      this.saveInProcess = true;
      this.showStatus = true;
      this.saveMessage.successMsgLbl = this.newUserTxt.successMsgLbl;
      this.saveMessage.errorMsgLbl = this.newUserTxt.errorMsgLbl;
      if (!response.isError) {
        this.statusMsg = this.saveMessage.successMsgLbl ? this.saveMessage.successMsgLbl:this.successMsgLbl;
        this.newUserDialog.showUserNameIcon = false;
        this.newUserDialog.isUserNameValid = false;
        this.addNewUserForm.reset();
      } else {
        this.statusMsg = this.saveMessage.errorMsgLbl ? this.saveMessage.errorMsgLbl :this.errorMsgLbl;
      }
    }, error => {
        this.statusMsg = this.saveMessage.errorMsgLbl ? this.saveMessage.errorMsgLbl : this.errorMsgLbl;
    })
  }

navigate(): void {
  this.router.navigateByUrl('/home');
}

  public close(status): void {
    this.saveInProcess = false;
    this.router.navigateByUrl('/home');
  }

  public checkUserNameAvailable() {
    var format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
    var userName = this.addNewUserForm.controls.userName.value;
    if (!userName || userName.length < 8) {
      this.newUserDialog.showUserNameIcon = true;
      this.newUserDialog.isUserNameValid = false;
      this.isUserNameVal= this.newUserTxt.userNameLbl ? this.newUserTxt.userNameLbl : this.newUserDialog.userNameLbl;
      return;
    }
    else if (format.test(userName)) {
      this.newUserDialog.showUserNameIcon = true;
      this.newUserDialog.isUserNameValid = false;
      this.isUserNameVal = this.newUserTxt.userNameSpecialCharLbl ? this.newUserTxt.userNameSpecialCharLbl : this.newUserDialog.userNameSpecialCharLbl;
      return;
    }
    this.newUserDialog.showUserNameIcon = false;
    this.newUserDialog.userNameProcessing = false;
    this.newUserDialog.isUserNameValid = false;
    this.newUserDialog.isEmptyUserName = false;
    this.newUserDialog.userNameProcessing = true;
    this.isDuplicateUser = false;
    this.userService.isUserNameAvailable(userName).subscribe((response: any) => {
      this.newUserDialog.userNameProcessing = false;
      if (!response.isError && response.data) {
        this.newUserDialog.showUserNameIcon = false;
        this.newUserDialog.isUserNameValid = true;
      }
      else {
        this.newUserDialog.showUserNameIcon = true;
        this.newUserDialog.isUserNameValid = false;
        this.isDuplicateUser = true;
        this.isUserNameVal = this.newUserTxt.userNotAvailableLbl ? this.newUserTxt.userNotAvailableLbl : this.newUserDialog.userNotAvailableLbl;
      }

    });
  }

  resetNewUserForm() {
    this.addNewUserForm.reset();
    this.newUserDialog.isSubmitted = false;
    this.newUserDialog.isemailNotMatched = false;
    this.newUserDialog.isEmailFormatInValid = false;
    this.newUserDialog.showUserNameIcon = false;
    this.newUserDialog.isUserNameValid = false;
    this.newUserDialog.isInvalidUserId = false;
    this.newUserDialog.isEmptyUserName = false;
    this.newUserDialog.showUserNameIcon = false;
    this.newUserDialog.userNameProcessing = false;
    this.newUserDialog.isInvalidFirstName = false;
    this.newUserDialog.isInvalidLastName = false;
    this.newUserDialog.isInvalidPhoneNumber = false;
    this.newUserDialog.isInvalidEmail = false;
    this.newUserDialog.isInvalidPhoneNumberMessage = false;
    this.newUserDialog.isInvalidBillingPhoneNumberMessage = false;
    this.newUserDialog.isInvalidConfirmEmail = false;
    this.newUserDialog.isInvalidCompanyName = false;
    this.newUserDialog.isInvalidCompanyAccNumber = false;
    this.newUserDialog.isInvalidPassword = false;
    this.isUserNameVal = '';
  }

  onValueChangeCompanyName(ev: string): void {
    this.charachtersCount = ev.length;
    this.counter = `${this.charachtersCount}/${this.maxlength}`;
  }

}

